import React from 'react'
import opensea from '../assets/images/opensea.svg'
import discord from '../assets/images/discord.svg'
import twitter from '../assets/images/twitter.svg'
import home from '../assets/images/home.svg'

const Header = () => (
  <>
    <div className="df-navbar">
        <div className="df-navbar-wrapper w-nav">
        <div className=" df-nav-grid">
            <a href=" " className="df-logo">z00tz Anchor Club</a>
            <div className="df-navbar-content">
            <a href="https://opensea.io/collection/z00tz-anchor-club" rel="noreferrer" target="_blank" className="df-btn-small df-btn-none w-inline-block"><img src={opensea} loading="lazy" alt="" className="df-img-small"/></a>
            <a href="https://discord.gg/4suKJtKy5w" target="_blank" rel="noreferrer" className="df-btn-small df-btn-none w-inline-block"><img src={discord} loading="lazy" alt="" className="df-img-small"/></a>
            <a href="https://twitter.com/z00tzAnchorClub" rel="noreferrer" target="_blank" className="df-btn-small df-btn-none w-inline-block"><img src={twitter} loading="lazy" alt="" className="df-img-small"/></a>
            <a  href="http://z00tzanchor.club/" className="df-btn-menu w-nav-button">
                <img width={"20px"} height={"20px"} src={home} loading="lazy" alt="" className="df-img-small"/>
            </a>
            <a href="https://raritysniper.com/nft-drops-calender"> NFT Drops</a>
            </div>
        </div>
        </div>
    </div>
  </>
)

export default Header